import {takeLatest, put, all, call} from 'redux-saga/effects';
import {successToast} from '../actions';
import * as AC from '../actions/actionTypes';
import {
  loginApi,
  getProfileApi,
  forgotPasswordApi,
  editProfileApi,
} from '../api/users.service';
import {errorHandler} from '../utils/errorHandler';

function* loginSaga(fn) {
  try {
    const response = yield call(loginApi, fn.payload);
    localStorage.setItem('token', response.data.token);
    yield put({type: AC.LOGIN_SUCCEED, payload: response.data});
    if (response.data.isTemporaryPassword) {
      yield put({type: AC.OPEN_MODAL, name: 'UpdatePasswordModal'});
    }
  } catch (e) {
    yield put({type: AC.LOGIN_FAILED, payload: e.message});
  }
}

function* getProfileSaga() {
  try {
    const response = yield call(getProfileApi);
    yield put({type: AC.GET_MY_PROFILE_SUCCEED, payload: response.data});
  } catch (e) {
    yield errorHandler(e, AC.GET_MY_PROFILE_FAILED);
  }
}

function* forgotPasswordSaga(fn) {
  try {
    const response = yield call(forgotPasswordApi, fn.email);
    yield put({type: AC.FORGOT_PASSWORD_SUCCEED, payload: response.data});
  } catch (e) {
    yield put({type: AC.FORGOT_PASSWORD_FAILED, payload: e.message});
  }
}

function* editProfileSaga(fn) {
  try {
    const response = yield call(editProfileApi, fn.payload);
    yield put({type: AC.EDIT_PROFILE_SUCCEED, payload: response.data});
    yield put(successToast('Profile edited successfully!'));
  } catch (e) {
    yield errorHandler(e, AC.EDIT_PROFILE_FAILED);
  }
}

function* actionWatcher() {
  yield takeLatest(AC.LOGIN_REQUEST, loginSaga);
  yield takeLatest(
    [AC.GET_MY_PROFILE_REQUEST, AC.EDIT_PROFILE_SUCCEED],
    getProfileSaga,
  );
  yield takeLatest(AC.FORGOT_PASSWORD_REQUEST, forgotPasswordSaga);
  yield takeLatest(AC.EDIT_PROFILE_REQUEST, editProfileSaga);
}

export default function* userSaga() {
  yield all([actionWatcher()]);
}
